// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"9cc7ae40","453":"19c27166","626":"aa148ee0"}[chunkId] + ".chunk.js";
};